module.exports = __webpack_public_path__ + "img/giaCertificate.85edb85.jpg";